
import React from 'react';
import { Award } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Card } from '@/components/ui/card';

const Certifications = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-white to-gray-50 relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.02]">
        <div className="w-full h-full" 
          style={{
            backgroundImage: "linear-gradient(45deg, #004080 1px, transparent 1px)",
            backgroundSize: "30px 30px"
          }}>
        </div>
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4 font-serif">
            IICRC Certified Excellence
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto mb-6"></div>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Gold Standard Cleaning Group holds the Institute of Inspection Cleaning and Restoration Certification (IICRC), 
            the gold standard in professional cleaning and restoration services.
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <Card className="relative group hover:shadow-xl transition-all duration-300 overflow-hidden">
            <div className="p-8">
              <div className="w-20 h-20 bg-navy/5 rounded-full flex items-center justify-center mb-6 mx-auto group-hover:scale-110 transition-transform">
                <Award className="h-10 w-10 text-navy" />
              </div>
              <Badge className="bg-gold/20 text-navy hover:bg-gold/30 mb-4 mx-auto">IICRC Certified</Badge>
              <h3 className="text-2xl font-serif font-bold text-navy mb-4 text-center">
                Industry's Highest Standard
              </h3>
              <p className="text-gray-600 text-center mb-6">
                Our IICRC certification demonstrates Gold Standard Cleaning Group's commitment to:
              </p>
              <ul className="space-y-3 text-gray-600">
                <li className="flex items-center justify-center gap-2">
                  <span className="w-2 h-2 bg-gold rounded-full"></span>
                  Advanced cleaning techniques for luxury surfaces
                </li>
                <li className="flex items-center justify-center gap-2">
                  <span className="w-2 h-2 bg-gold rounded-full"></span>
                  Expert handling of delicate materials and finishes
                </li>
                <li className="flex items-center justify-center gap-2">
                  <span className="w-2 h-2 bg-gold rounded-full"></span>
                  Continuous education and skill enhancement
                </li>
                <li className="flex items-center justify-center gap-2">
                  <span className="w-2 h-2 bg-gold rounded-full"></span>
                  Adherence to industry-leading standards
                </li>
              </ul>
            </div>
            <div className="absolute inset-0 border border-gold/20 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity"></div>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default Certifications;
